import { render, staticRenderFns, recyclableRender, components } from "./freight-certification.vue?vue&type=template&id=4a783bb0&scoped=true&"
var renderjs
import script from "./freight-certification.vue?vue&type=script&lang=js&"
export * from "./freight-certification.vue?vue&type=script&lang=js&"
import style0 from "./freight-certification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./freight-certification.vue?vue&type=style&index=1&id=4a783bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a783bb0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/freight-certification/freight-certification.vue"
export default component.exports